// TODO: Later: Make this a panel against ArtifactVersion

import {
  opArtifactName,
  opArtifactProject,
  opArtifactTypeName,
  opArtifactVersionArtifactSequence,
  opArtifactVersionArtifactType,
  opArtifactVersionHash,
  opDict,
  opEntityName,
  opProjectEntity,
  opProjectName,
  OutputNode,
} from '@wandb/weave-ui/cg';
import {useNodeValue} from '@wandb/weave-ui/cgreact';
import * as Panel2 from '@wandb/weave-ui/components/Panel2/panel';
import * as React from 'react';

import {trackArtifactLineageTabInteraction} from '../../../util/navigation';
import ArtifactDag from '../../ArtifactDag';

const inputType = 'artifactVersion' as const;
type ConfigType = {};

export const PanelArtifactVersionLineage: React.FC<
  Panel2.PanelProps<typeof inputType, ConfigType>
> = ({input: artifactVersionNode}) => {
  React.useEffect(() => {
    // Use to track when lineage tab is clicked
    trackArtifactLineageTabInteraction('direct-lineage-default');
  }, []);
  const {result, loading} = useNodeValue(
    React.useMemo(() => {
      // Here we do extra walks to guarantee we are looking at the sequence flavour
      // to ensure there is a hash to use for the dag.
      const artifactNode = opArtifactVersionArtifactSequence({
        artifactVersion: artifactVersionNode,
      });
      const projectNode = opArtifactProject({artifact: artifactNode});

      return opDict({
        artifactTypeName: opArtifactTypeName({
          artifactType: opArtifactVersionArtifactType({
            artifactVersion: artifactVersionNode,
          }),
        }),
        entityName: opEntityName({
          entity: opProjectEntity({project: projectNode}),
        }),
        projectName: opProjectName({
          project: projectNode,
        }),
        artifactSequenceName: opArtifactName({
          artifact: artifactNode,
        }),
        commitHash: opArtifactVersionHash({
          artifactVersion: artifactVersionNode,
        }),
      } as any) as unknown as OutputNode<'any'>;
    }, [artifactVersionNode])
  );

  // When an anon user (not logged in) tries to view a private artifact's lineage, artifactTypeName and
  // artifactSequenceName will be null. ['private' meaning that the artifact belongs to a private project].
  if (
    loading ||
    result.artifactTypeName == null ||
    result.artifactSequenceName == null
  ) {
    return <></>;
  }
  return (
    <ArtifactDag
      entityName={result.entityName}
      projectName={result.projectName}
      artifactTypeName={result.artifactTypeName}
      artifactCollectionName={result.artifactSequenceName}
      artifactCommitHash={result.commitHash}
    />
  );
};
